import { createSlice } from "@reduxjs/toolkit";
import { dimensions } from "../../utils/helper";

const obj = [
  {
    image: "",
    label: "Master",
  },
];
const imgs = Object.keys(dimensions)?.map((size) => {
  return {
    label: size,
    image: "",
  };
});
obj.push(...imgs);
const initialState = {
  thumbList: [],
  tshirtList: [],
  designThumbs: [...obj],
};

const thumbnailSlice = createSlice({
  name: "thumbnails",
  initialState,
  reducers: {
    clearThumb: (state) => {
      state.thumbList = [];
    },
    setThumbsList: (state, action) => {
      state.thumbList = action.payload.thumbList;
    },
    pushThumbnailInList: (state, action) => {
      let list = state.thumbList ? [...state.thumbList] : [];
      list.push(action.payload);
      state.thumbList = list;
    },

    setThumb: (state, action) => {

      let findIndex = state?.thumbList?.findIndex(item => parseInt(item?.tShirtInfo?.indexSr) === parseInt(action?.payload?.tShirtInfo?.indexSr));
      if(findIndex !== -1 && findIndex !== undefined){
        state.thumbList[findIndex] = action.payload;
      }
      else{
        if(Array.isArray(state.thumbList)){
          state.thumbList.push(action.payload);
        }
        else{
          state.thumbList = [action.payload];
        }
      }
    },

    setTshirtList: (state, action) => {
      state.tshirtList = action.payload;
    },
    designScreenThumbs: (state, action) => {
      state.designThumbs = action.payload;
    },
    pushToDesignThumbs: (state, action) => {
      let list = [...state.designThumbs];
      list.push(action.payload);
      state.designThumbs = list;
    },
  },
});

export const {
  designScreenThumbs,
  pushToDesignThumbs,
  clearThumb,
  setThumbsList,
  pushThumbnailInList,
  setTshirtList,
  setThumb,
} = thumbnailSlice.actions;

export default thumbnailSlice.reducer;
